export const PLAY_IN_STADIUM_ICON = 'PLAY_IN_STADIUM_ICON'
export const BRING_OUT_CRICKETER_IN_YOU_ICON = 'BRING_OUT_CRICKETER_IN_YOU_ICON'
export const COMPETE_WITH_YOUR_FRIENDS_ICON = 'COMPETE_WITH_YOUR_FRIENDS_ICON'
export const BE_A_VR_CRICKETER_ICON = 'BE_A_VR_CRICKETER_ICON'



// WEBPACK FOOTER //
// ./src/components/IbcArcade/PlayInInternationalStrip/constants.js